<template>
	<div class="qualifier custom-filter-match">
		<div class="title">
			<div class="name">Custom Filter Match</div>
			<delete-action
				text
				rounded
				icon="close"
				message="Are you sure you want to remove this qualifier?"
				tooltip="Remove Qualifier"
				@delete="removeQualifier"
			/>
		</div>
		<div class="description">Disqualify a campaign if it does not match the specified custom filter.</div>
		<div class="step-settings">
			<h3>Settings</h3>
			<div class="control-group">
				<div class="inner">
					<label class="control-label">Custom Filter Match:</label>
					<div class="controls gap-20">
						<div class="field">
							<code-editor v-model.parse="modelValue.match" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import codeEditor from '@/components/forms/CodeEditor.vue';
import deleteAction from '@/components/widgets/DeleteAction.vue';

export default {
	name: 'CustomFilterMatchQualifier',
	emits: ['remove'],
	components: {
		codeEditor,
		deleteAction,
	},
	props: {
		modelValue: {
			type: Object,
			default() {
				return {
					match: [
						[
							{
								target: {
									path: '',
								},
								strategy: 'equals',
								comparator: {
									value: '',
								},
							},
						],
					],
				};
			},
		},
	},
	methods: {
		removeQualifier() {
			this.$emit('remove');
		},
	},
};
</script>
